import { AnyAction } from "redux";
import { FETCH_SCHOOL_AUTHS, RECEIVE_SCHOOL_AUTHS, SAVE_SCHOOL_AUTH, SAVE_SCHOOL_AUTH_SUCCESS, DELETE_SCHOOL_AUTH, DELETE_SCHOOL_AUTH_SUCCESS } from "../actionTypes";

interface SchoolAuthState {
    isFetching: boolean;
    isSaving: boolean;
    schoolAuthorizations: any[];
}

const initialState: SchoolAuthState = {
    isFetching: false,
    isSaving: false,
    schoolAuthorizations: [],
}

const schoolAuthReducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case FETCH_SCHOOL_AUTHS: return { ...state, isFetching: true };
        case RECEIVE_SCHOOL_AUTHS: return { ...state, isFetching: false, schoolAuthorizations: action.payload };
        case SAVE_SCHOOL_AUTH: return { ...state, isSaving: true };
        case SAVE_SCHOOL_AUTH_SUCCESS: return { ...state, isSaving: false };
        case DELETE_SCHOOL_AUTH: return { ...state, isSaving: true };
        case DELETE_SCHOOL_AUTH_SUCCESS: return { ...state, isSaving: false };
        default: return state;
    }
}
export default schoolAuthReducer;
